export default __webpack_public_path__ + "static/media/excellent.615e99b7.svg";